import React, { useState } from "react";
import SidebarMenuItem from "./SidebarMenuItem";
import { classNames } from "../../helpers/classNames";

import { useLocation } from "react-router-dom";

const SidebarMenuBlocks = ({
  menuTitle,
  mainMenuIcon,
  menuData,
  isExpanded,
  onToggle,
  isMenuOpen
}) => {
  const location = useLocation();

  const isAnyChildActive = menuData?.some((item) => {
    return item?.menuLink === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(item?.menuLink);
  });

  return (
    <div className="relative py-3 px-4 transition-all duration-100">
      {menuTitle && (
        <div
          className={classNames(
            "flex items-center justify-between text-sm capitalize font-normal cursor-pointer pb-3 transition-all duration-300",
            isAnyChildActive
              ? "text-primary"
              : " text-sidebartext hover:text-zinc-950"
          )}
          onClick={onToggle}
        >
          <div className="flex gap-3">
            <span>
              <i className={mainMenuIcon || "fa-regular fa-table-columns"}></i>
            </span>
            <span>{menuTitle}</span>
          </div>
          <div>
            {isExpanded ? (
              <i className="fa-solid fa-chevron-down h-4 w-4 text-gray-200" />
            ) : (
              <i className="fa-solid fa-chevron-up h-4 w-4 text-gray-200" />
            )}
          </div>
        </div>
      )}
      <div
        className={classNames(
          "transition-all duration-500 overflow-hidden -mx-2 px-2",
          isExpanded ? "max-h-[2000px]" : "max-h-0"
        )}
      >
        <div className="space-y-1">
          {menuData?.map((item, i) => (
            <SidebarMenuItem
              key={item?._id + i}
              menuLink={item.menuLink}
              menuIcon={item.menuIcon}
              menuIconColor={item.menuIconColor}
              menuLabel={item.menuLabel}
              isMenuOpen={isMenuOpen}
              blank={item?.blank}
            />
          ))}
        </div>
      </div>
    </div>
  );
};



export default SidebarMenuBlocks;
